"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function loadScript(src, evaluate) {
    return new Promise(function (resolve, reject) {
        var script = document.querySelector("script[src=\"" + src + "\"]");
        if (script) {
            var retryCounter_1 = 0;
            var interval_1 = setInterval(function () {
                if (typeof evaluate === 'function' &&
                    (script === null || script === void 0 ? void 0 : script.getAttribute('fe-loaded-state')) === 'loaded') {
                    clearInterval(interval_1);
                    resolve(evaluate());
                }
                else {
                    retryCounter_1++;
                }
                if (retryCounter_1 > 10) {
                    reject();
                    clearInterval(interval_1);
                }
            }, 1000);
        }
        if (!script) {
            script = document.createElement('script');
            if (src.indexOf('https://') === 0) {
                script.setAttribute('crossOrigin', '');
            }
            script.async = true;
            script.src = src;
        }
        script.onload = function () {
            script === null || script === void 0 ? void 0 : script.setAttribute('fe-loaded-state', 'loaded');
            if (typeof evaluate === 'function') {
                resolve(evaluate());
            }
            else {
                resolve();
            }
        };
        script.onerror = function () {
            script === null || script === void 0 ? void 0 : script.setAttribute('fe-loaded-state', 'error');
            var error = 'Error from loadScript';
            if (typeof window !== 'undefined' && window.newrelic) {
                window.newrelic.noticeError(error, {
                    type: 'javascript',
                    src: src,
                });
            }
            reject();
        };
        if (!script.parentElement) {
            document.head.appendChild(script);
        }
    });
}
exports.default = loadScript;
